export const isFullUrl = (url) => {
    return (url === null || url === void 0 ? void 0 : url.startsWith('http://')) || (url === null || url === void 0 ? void 0 : url.startsWith('https://'));
};
export const fixVideoThumbnailFromMobile = (url) => {
    var _a;
    let resultUrl = url;
    if (url) {
        if (isFullUrl(url)) {
            // at this place the url for thumbnail can be absolute
            //   and we should cut the media id from the full url (specific for mobile media manager)
            resultUrl = (_a = url.match(/\/(media\/.*?\..*?)(\/|$)/)) === null || _a === void 0 ? void 0 : _a[1];
            if (!resultUrl) {
                console.error('Error with absolute thumbnail url:', url);
            }
        }
        else if (!url.includes('media/')) {
            resultUrl = `media/${url}`;
        }
    }
    return resultUrl;
};
export function getVideoUrl(url) {
    return ('https://video.wixstatic.com/' +
        ((url === null || url === void 0 ? void 0 : url.split('/').length) > 2 ? url : `${url}/720p/mp4/file.mp4`));
}
export const getVideoTypeFromUrl = (url) => {
    return `video/${url.split('.').pop()}`;
};
//# sourceMappingURL=video.js.map